<template>
  <div>
    <div
      v-if="capacity >= 55"
      class="alert alert-distinction offset-border"
    >
      <ul class="icons">
        <li>
          <i class="icon"><icon-alarm-exclamation /></i>
          <div>
            {{ $t('search:percentageIsBookedOut', {capacity:capacity}) }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

/* ICONS */
import IconAlarmExclamation from 'ICON:IconAlarmExclamation';

export default {
  name: 'SearchCapacity',
  i18nOptions: { namespaces: 'search' },
  components: {
    IconAlarmExclamation,
  },
  computed: {
    capacity() {
      return this.$store.state.searchCapacity;
    },
  },
};
</script>
